import './Experts.css'


const Experts = () => {        
    return (        
        <>
            <div className="oracle-expert-banner">
                <img src={process.env.PUBLIC_URL + "/images/salesforce/Expertbanner.png"} alt="Expert Banner" />
            </div>
            <div className="oracle-expert-content">
                <p>
                Meet the minds behind ATCI’s intensive, innovative, fit-for-market Saleforce learning programs, enabling Accenture to lead in the marketplace and deliver on the promise of client excellence.
                </p>
            </div>
            <div className="experts_container">            
                <img src="/images/salesforce/Experts/praveen_rajaram.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/s_saraswathi.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/Suresh HN.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/Krishna Kishore.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/Simhadri Pv.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/Shaik Shaikshavali.png" alt="Expert" className="saleForce_expert" />                                                                
                <img src="/images/salesforce/Experts/Monish Aditya.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/Sruthi Tatapudi.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/srividya_murali.png" alt="Expert" className="saleForce_expert" />
                <img src="/images/salesforce/Experts/pooja_kudale.png" alt="Expert" className="saleForce_expert" />                                                                  
                <img src="/images/salesforce/Experts/mrunal_khandagale.png" alt="Expert" className="saleForce_expert" />               
                <img src="/images/salesforce/Experts/aparna_vedpathak.png" alt="Expert" className="saleForce_expert" />                                
                <img src="/images/salesforce/Experts/amit_cy_sharma.png" alt="Expert" className="saleForce_expert" />                
                <img src="/images/salesforce/Experts/manish_bv_sharma.png" alt="Expert" className="saleForce_expert" />                                
            </div>
        </>        
    );
};

export default Experts